var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurity({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140.483,
    height: 158.807,
    viewBox: "0 0 140.483 158.807",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "security-shield-green",
    d: "M79.241,76.241A7.633,7.633,0,0,0,75.424,90.5v6.352a3.817,3.817,0,0,0,7.635,0V90.5a7.633,7.633,0,0,0-3.817-14.262Zm0-30.54C67.972,45.7,64.216,48.3,64,64.026H94.481C94.267,48.3,90.511,45.7,79.241,45.7Zm0,0C67.972,45.7,64.216,48.3,64,64.026H94.481C94.267,48.3,90.511,45.7,79.241,45.7Zm0,30.54A7.633,7.633,0,0,0,75.424,90.5v6.352a3.817,3.817,0,0,0,7.635,0V90.5a7.633,7.633,0,0,0-3.817-14.262Zm64.133-58.026C103.673,18.216,85.349,6,85.349,6H73.133S54.81,18.216,15.108,18.216L9,24.324V85.4c0,58.026,70.241,79.4,70.241,79.4s70.241-21.378,70.241-79.4V24.324Zm-30.54,88.107a6.556,6.556,0,0,1-6.566,6.566H52.214a6.556,6.556,0,0,1-6.566-6.566V70.592a6.556,6.556,0,0,1,6.566-6.566H54.84c.244-17.011,4.642-27.486,24.4-27.486s24.157,10.475,24.4,27.486h2.626a6.556,6.556,0,0,1,6.566,6.566ZM79.241,45.7C67.972,45.7,64.216,48.3,64,64.026H94.481C94.267,48.3,90.511,45.7,79.241,45.7Zm0,30.54A7.633,7.633,0,0,0,75.424,90.5v6.352a3.817,3.817,0,0,0,7.635,0V90.5a7.633,7.633,0,0,0-3.817-14.262Z",
    transform: "translate(-9 -6)",
    fill: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.45d04b037f99ca083a3c139fab89950a.svg";
export { ForwardRef as ReactComponent };